import styled from 'styled-components';

export { StepContainer, StepIndicator, StepHeader, StepTitle, StepDescription } from '../step-shared/StepShared.styles.js';

export const CardFlow = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 24px;
    justify-content: center;
    width: 100%;

    @media (min-width: 792px) {
        flex-direction: row;
        flex-wrap: wrap;
    }
`;

export const DemoCard = styled.div`
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid ${props => props.$isUnlocked ? 'rgba(255, 255, 255, 0.33)' : 'rgba(255, 255, 255, 0.33)'};
    border-radius: 16px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
    cursor: default;
    padding: 8px;
    transition: all 0.3s ease;
    width: 280px;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 12px rgba(0, 0, 0, 0.15);
        border-color: ${props => props.$isUnlocked ? 'rgba(255, 255, 255, 0.67)' : 'rgba(255, 255, 255, 0.2)'};
    }

    ${props => !props.$isUnlocked && `
        opacity: 0.8;
        background: rgba(255, 255, 255, 0.1);
    `}
`;

export const DemoCardContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    min-width: 0;
`;

export const CardImageContainer = styled.div`
    width: 100%;
    height: 180px;
    border-radius: 8px;
    overflow: hidden;
    background-color: #333;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
`;

export const CardImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
    filter: ${props => props.$isLocked ? 'blur(1.5px)' : 'none'};
`;

export const LockOverlay = styled.div`
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
`;

export const LockIconImg = styled.img`
    height: 48px;
    opacity: 0.8;
    width: 48px;
`;

export const LockIconSmall = styled.img`
    height: 20px;
    opacity: 0.7;
    width: 20px;
`;

export const CardLabel = styled.div`
    align-items: center;
    display: flex;
    height: 48px;
    justify-content: center;
    text-align: center;

    h3 {
        margin: 0;
        font-size: 16px;
        font-weight: 600;
    }
`;

export const CardDetails = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 8px;
    justify-content: center;
    min-width: 0;
    width: 100%;
`;

export const UnlockButton = styled.button`
    align-items: center;
    background: none;
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 8px;
    box-sizing: border-box;
    cursor: default;
    display: flex;
    font-size: 12px;
    font-weight: 600;
    gap: 8px;
    justify-content: center;
    min-width: 0;
    padding: 8px 16px;
    transition: all 0.2s ease;
    width: 100%;

    h4 {
        margin: 0;
    }
`;

export const OpenButton = styled.div`
    align-items: center;
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 8px;
    box-sizing: border-box;
    cursor: default;
    display: flex;
    font-size: 12px;
    font-weight: 600;
    gap: 8px;
    justify-content: center;
    min-width: 0;
    padding: 8px 16px;
    transition: all 0.2s ease;
    width: 100%;

    h4 {
        margin: 0;
    }
`;

export const FlowArrow = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const ArrowIcon = styled.span`
    color: rgba(255, 255, 255, 0.85);
    font-size: 24px;

    @media (max-width: 791px) {
        display: inline-block;
        transform: rotate(90deg);
    }
`;

export const TokenIcon = styled.img`
    height: 32px;
    width: 32px;
`;
